module.exports = __webpack_public_path__ + "static/img/bcg2.bdf892bf.png";